module.exports = __webpack_public_path__ + "static/media/AboutUs.4939f648.png";